// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner[data-v-c48435fc]{display:block}.banner[data-v-c48435fc] code{padding:0 3px;margin:0 3px}.advanced-ldap-banner[data-v-c48435fc]{display:flex;flex:1}.advanced-ldap-banner[data-v-c48435fc]>:first-child{flex:1}.advanced-ldap-banner .toggle-btn[data-v-c48435fc]{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
